<template>
    <div class="changePhone">
        <div class="changePhone-content">
            <p class="changePhone-newNum">当前手机号码</p>
            <p class="changePhone-newNum-content">{{ parsePhoneToStar(userInfo.phoneNo) }}</p>
            <p class="changePhoen-newNum-tip">成功更换手机号后，下次登录使用新手机号登录</p>
            <div class="changePhone-code">
                <van-field v-model="code" center clearable placeholder="请输入短信验证码">
                    <template #button>
                        <span class="sendCodeBtn" @click="sendCode">{{ sendCodeText }}</span>
                    </template>
                </van-field>
            </div>
        </div>
        <div class="changePhone-confirm-btn">
            <van-button class="comfirm-btn" :disabled="disabled" @click="toChangePhone">立即更换</van-button>
        </div>
    </div>
</template>

<script>
import { parsePhoneToStar, parseSmsKey } from "@/libs/parseData";
import { getUserInfoApi, sendSmsApi, checkSmsCode } from "@/api/index";
import config from "@/config/index";
export default {
    name: "ChangePhone",
    data() {
        return {
            userInfo: {},
            phone: "",
            code: "",
            second: 60,
            timer: null,
            sendCodeText: "获取短信验证码",
        };
    },
    computed: {
        disabled() {
            if (this.code.length == 4) {
                return false;
            } else {
                return true;
            }
        },
    },
    created() {
        this.getUserInfo();
    },
    methods: {
        parsePhoneToStar,
        // 获取用户信息
        getUserInfo() {
            getUserInfoApi().then((res) => {
                this.userInfo = res.data;
            });
        },
        sendCode() {
            if (this.second == 60) {
                let params = {
                    accessKey: config.accessKey,
                    accessToken: parseSmsKey(this.userInfo.phoneNo),
                    phoneNo: this.userInfo.phoneNo,
                };
                sendSmsApi(params).then((res) => {
                    this.timer = setInterval(() => {
                        if (this.second > 0) {
                            this.second -= 1;
                            this.sendCodeText = this.second + "s后重新获取";
                        } else {
                            this.sendCodeText = "获取短信验证码";
                            this.second = 60;
                            clearInterval(this.timer);
                        }
                    }, 1000);
                    this.$notify({
                        message: "验证码已发送，请注意查收",
                        color: "#009AF3",
                        background: "#D3E8FB",
                    });
                });
            } else {
            }
        },
        toChangePhone() {
            checkSmsCode({
                captchaCode: this.code,
                phoneNo: this.userInfo.phoneNo,
            }).then((res) => {
                if (res.code == 200) {
                    this.$router.push({
                        name: "ChangeNewPhone",
                        query: {
                            oldPhoneNo: this.userInfo.phoneNo,
                        },
                    });
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/color.less";
.comfirm-btn {
    background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
}
.changePhone {
    min-height: 100vh;
    background-color: #fff;

    .changePhone-content {
        padding: 124px 72px;

        .changePhone-newNum {
            font-size: 32px;
            font-weight: 500;
            color: #666666;
        }

        .changePhone-newNum-content {
            font-size: 60px;
            font-weight: 500;
            color: #333333;
            margin: 23px 0 31px;
        }

        .changePhoen-newNum-tip {
            font-size: 26px;
            color: #999999;
        }
        .changePhone-code {
            margin-top: 150px;
            border-bottom: 1px solid #dbdada;
            padding-bottom: 34px;
            .sendCodeBtn {
                color: @main-color;
                font-size: 28px;
            }
        }
    }
    .changePhone-confirm-btn {
        padding: 24px;
        // margin-top: ;
    }
}
</style>
<style lang="less">
.changePhone-code {
    .van-cell {
        padding: 0;
    }
}
</style>
